import React from 'react';
import './SectionTitle.css';

export type SectionTitleProps = {
  title: string;
  subtitle?: string;
  className?: string;
};

/**
 * SectionTitle component matching Terrapin Trade rebrand design
 * Features:
 * - Purple gradient dot (12px)
 * - White text on dark background
 * - Optional subtitle in muted color
 */
export const SectionTitle: React.FC<SectionTitleProps> = ({
  title,
  subtitle,
  className = '',
}) => {
  return (
    <div className={`tt-section-title ${className}`} data-tt-section-title>
      <span className="tt-section-dot" aria-hidden="true" />
      <div className="tt-section-text-wrap">
        <h1 className="tt-section-title-text">{title}</h1>
        {subtitle && <p className="tt-section-subtitle">{subtitle}</p>}
      </div>
    </div>
  );
};

export default SectionTitle;

